import {
    ShieldCheck,
    FileSpreadsheet,
    Calculator,
    BadgeCheck,
    Receipt,
    Users,
    Wallet,
    Building2,
    LineChart,
    Landmark,
    Scale,
    BookOpenCheck,
    FileCheck,
    Award,
    ArrowRightLeft,
} from "lucide-react";

export const services = [
    {
        slug: "personal-tax",
        title: "Personal Tax Returns",
        icon: FileCheck,
        summary:
            "We handle individual income tax returns from the straightforward to the highly complex — ensuring every legitimate deduction is claimed and your filing is submitted accurately and on time.",
        bullets: [
            "ITR12 submissions for employed & self-employed individuals",
            "Home office, RA, medical & travel deductions",
            "Sideline business & independent contractor returns",
        ],
    },
    {
        slug: "external-audit",
        title: "External Audits",
        icon: ShieldCheck,
        summary:
            "Independent statutory audits performed in accordance with International Standards on Auditing (ISA), suited to companies, NPOs, schools, body corporates and trusts requiring an audit opinion.",
        bullets: [
            "Public Interest Score audits",
            "Companies Act s.30 audit opinions",
            "ISA-compliant work papers and reporting",
        ],
    },
    {
        slug: "independent-review",
        title: "Independent Reviews",
        icon: BadgeCheck,
        summary:
            "Independent Reviews under ISRE 2400 for companies whose Public Interest Score and ownership structure permit a Review rather than a full Audit.",
        bullets: [
            "Cost-effective alternative to a full audit",
            "Compliance with Companies Regulation 29",
            "Limited assurance reporting",
        ],
    },
    {
        slug: "compilations",
        title: "Annual Financial Statements",
        icon: FileSpreadsheet,
        summary:
            "Compiled, Reviewed or Audited AFS prepared in line with IFRS or IFRS for SMEs — submitted to CIPC and SARS on your behalf.",
        bullets: ["IFRS / IFRS for SMEs", "CIPC submissions via XBRL", "SARS ITR14 alignment"],
    },
    {
        slug: "taxation",
        title: "Taxation & SARS",
        icon: Calculator,
        summary:
            "Income Tax, VAT, PAYE, Provisional Tax, Dividends Tax and SARS dispute support — for companies, trusts, sole proprietors and individuals.",
        bullets: ["ITR14, ITR12, IRP6", "VAT201 & EMP201/501", "Objections, disputes & VDP"],
    },
    {
        slug: "accounting",
        title: "Accounting & Bookkeeping",
        icon: BookOpenCheck,
        summary:
            "End-to-end cloud bookkeeping on Xero — bank feeds, invoicing, supplier bills, reconciliations and management accounts.",
        bullets: ["Live cloud bookkeeping", "Monthly / quarterly management accounts", "Designated SAIPA / SAICA accountant"],
    },
    {
        slug: "payroll",
        title: "Payroll Services",
        icon: Users,
        summary:
            "Outsourced payroll with EMP201, EMP501 and IRP5 submissions to SARS — fully integrated with Xero or run on Simplepay / Sage.",
        bullets: ["UIF, SDL, PAYE submissions", "EMP501 reconciliations", "IRP5/IT3(a) certificates"],
    },
    {
        slug: "secretarial",
        title: "Company Secretarial & CIPC",
        icon: Building2,
        summary:
            "CIPC company registrations, annual returns, director changes, BEE affidavits and beneficial ownership filings.",
        bullets: ["CIPC annual returns", "Beneficial ownership register", "BEE affidavit certificates"],
    },
    {
        slug: "advisory",
        title: "Profitability & Tax Advisory",
        icon: LineChart,
        summary:
            "Strategic reviews of your business profit, cash flow and tax structure — designed to legally reduce your tax burden and grow your bottom line.",
        bullets: ["Profit reviews", "Tax structuring", "Cash-flow forecasting"],
    },
    {
        slug: "estates",
        title: "Estates, Wills & Trusts",
        icon: Landmark,
        summary:
            "Estate planning, executorship support, trust accounting and trust tax returns — protecting family wealth across generations.",
        bullets: ["Inter-vivos & testamentary trusts", "Estate duty planning", "Trust IT12TR returns"],
    },
    {
        slug: "vat",
        title: "VAT Compliance",
        icon: Receipt,
        summary:
            "VAT registrations, monthly / bi-monthly VAT201 review and submission, and SARS VAT verification support.",
        bullets: ["VAT registrations & deregistrations", "VAT201 review & e-filing", "VAT audit & verification support"],
    },
    {
        slug: "wealth",
        title: "Business Profit Reviews",
        icon: Wallet,
        summary:
            "Quarterly profit reviews to identify margin leaks, savings opportunities, and AI-driven process automations across your business.",
        bullets: ["Margin analysis", "AI process automations (Zapier + ChatGPT)", "Tax-saving opportunities"],
    },
    {
        slug: "compliance",
        title: "Companies Act Compliance",
        icon: Scale,
        summary:
            "Holistic Companies Act 71 of 2008 compliance — from share registers and MOI amendments to Public Interest Score calculations.",
        bullets: ["MOI amendments", "Share registers", "Public Interest Score calc"],
    },
    {
        slug: "bee-affidavits",
        title: "BEE Affidavits",
        icon: Award,
        summary:
            "We issue B-BBEE Level 4 EME and QSE affidavits in accordance with the B-BBEE Act — a fast, cost-effective and legally compliant route for smaller businesses to demonstrate their BEE status.",
        bullets: [
            "EME affidavits for turnover below R10 million",
            "QSE affidavits for turnover R10m – R50 million",
            "IRBA-recognised CA(SA) signatory",
            "Fast turnaround — typically within 48 hours",
        ],
    },
    {
        slug: "xero-migration",
        title: "Xero Migration & Training",
        icon: ArrowRightLeft,
        summary:
            "We migrate any accounting system — Pastel, Sage, QuickBooks, Excel or any other platform — to Xero with complete accuracy, preserving up to five years of historical data. Every migration includes full Xero training for your team.",
        bullets: [
            "Migration from Pastel, Sage, QuickBooks & Excel",
            "Up to 5 years of historical data transferred",
            "Full chart of accounts mapping & reconciliation",
            "Xero staff training included in all packages",
        ],
    },
];
